/* eslint-disable */
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const EventListHeader = ({
  updateRankHandler,
  reloadEventList,
  selectedEventIds = [],
}) => {
  const { t } = useTranslation(); //for translation
  const breadcrumbText = [{ title: t("Event") }];

  return (
    <div className="bg-white py-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>

        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <Link
            onClick={reloadEventList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* ------- action section ---------- */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>

            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedEventIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedEventIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedEventIds.length === 0 ? undefined : "#addLabelModal"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedEventIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={() => {
                    if (selectedEventIds.length > 0) {
                      updateRankHandler();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    progress_activity
                  </span>
                  <span className="d-block">{t("Update Rank")}</span>
                </Link>
              </li>
              {/* //addfollower  */}
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedEventIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  data-bs-toggle={
                    selectedEventIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedEventIds.length === 0 ? undefined : "#addFollowers"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    person_add
                  </span>
                  <span className="d-block">{t("Add Followers")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedEventIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedEventIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedEventIds.length === 0 ? undefined : "#deletewarning"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* --------- filter ---------- */}
          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasEventFilter"
            aria-controls="offcanvasEventFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
          </Link>

          {/* ----------- add new ------------ */}
          <Link
            to="#"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            data-bs-toggle="modal"
            data-bs-target="#eventTypeModal"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add New")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventListHeader;
